import React from 'react';
import { motion } from 'framer-motion';

export default function HeroBackground() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.15 }}
      transition={{ duration: 1 }}
      className="absolute inset-0 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=2850&q=80')] bg-cover bg-center opacity-10" />
      <div className="absolute inset-0 bg-gradient-to-t from-dark via-transparent to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-b from-dark-lighter to-dark opacity-90" />
    </motion.div>
  );
}